// extracted by mini-css-extract-plugin
export default {"container":"cK-z","dimension":"dK-z","dimensionLabels":"eK-z"};